import { Dialog, DialogContent } from "@mui/material";
import React from "react";
import TitleForm from "./TitleForm";
import QuantityForm from "../../../shared/QuantityForm/QuantityForm";
import AppDialog from "../../../shared/ui/AppDialog";
// open={Boolean(modalType)}
// onClose={handleCloseModal}
// modalType={modalType}
// modalRef={modalRef}
// setModalType={setModalType}
// setTitle={setTitle}
// title={title}
// quantity={quantity}
// setQuantity={setQuantity}
function ProductInfoModal({
  modalType,
  modalRef,
  setModalType,
  setTitle,
  title,
  quantity,
  setQuantity,
  onClose,
  open,
}) {
  const renderContent = () => {
    switch (modalType) {
      case "quantity":
        return (
          <QuantityForm
            onClose={onClose}
            quantity={quantity}
            setQuantity={setQuantity}
          />
        );

      case "title":
        return (
          <TitleForm onClose={onClose} title={title} setTitle={setTitle} />
        );
      default:
        return null;
    }
  };

  return (
    <AppDialog open={open} onClose={onClose} ref={modalRef}>
      {renderContent()}
    </AppDialog>
  );
}

export default ProductInfoModal;
